export default __webpack_public_path__ + "static/media/cryptocurrencyappSmall.4d790fc9.jpg";